<div class="is-relative">
        <a *ngIf="displayCloseButton" class="has-text-black close-button" (click)="closeForm()"><i class="fas fa-times"></i></a>
</div>
<ng-content></ng-content>
<ng-template [ngIf]="loading && !error" class="is-flex align-center">
    <span><img src="assets/images/loader.svg"/></span>
    Loading {{title}} ...</ng-template>
<ng-template [ngIf]="error">Error Loading {{title}}</ng-template>
